import initialState from 'store/initialState';
import { ActionTypes, ChecklistActionTypes } from './types';

export default function checklistReducer(
  state = initialState.checklist,
  action: ChecklistActionTypes
) {
  switch (action.type) {
    case ActionTypes.TOGGLE_CHECK: {
      const ids = Object.keys(action.payload);
      const checkitemId = ids.length && ids[0];
      const stateCopy = { ...state };
      for (const checklistId of Object.keys(stateCopy)) {
        if (stateCopy[checklistId]?.[checkitemId] !== undefined) {
          stateCopy[checklistId][checkitemId].isChecked = action.payload[checkitemId].isChecked;
          break;
        }
      }
      return stateCopy;
    }
    case ActionTypes.INIT_CHECKLIST:
      if (action.checklistPayload) {
        return { ...state, ...action.checklistPayload };
      }
      return state;
    default:
      return state;
  }
}
